Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var core = require('@material-ui/core');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var useStyles = function useStyles(contrast) {
  return core.makeStyles(function (theme) {
    return {
      container: {
        color: contrast ? theme.palette.primary.contrastText : theme.palette.text.secondary
      },
      heading: {
        lineHeight: "12px"
      },
      nextHeading: {
        marginBottom: "0.6em"
      }
    };
  });
};
var PortletTitle = function PortletTitle(_a) {
  var title = _a.title,
    contrast = _a.contrast,
    children = _a.children;
  var classes = useStyles(contrast)();
  return React__default['default'].createElement(core.Box, {
    className: classes.container
  }, React__default['default'].createElement(core.Typography, {
    component: "h3",
    gutterBottom: true,
    variant: "overline",
    color: "inherit",
    classes: {
      overline: classes.heading
    }
  }, title), React__default['default'].createElement(core.Typography, {
    variant: "h2",
    color: "inherit"
  }, children));
};
exports.default = PortletTitle;